<section id='pricing' class='background-10' ngClass.gt-xs='section-full' ngClass.lt-sm='section-mobile'>
    <h1 class='membership-options'>PRICING</h1>
    <div class='membership-options'>
        <div fxLayout='row' fxLayout.xs='column' fxLayoutAlign='center center' fxLayoutAlign.xs='center center'>
            <mat-card [@flipInY]='animatePricing()' ngClass.lt-sm='mat-card-mobile' ngClass.gt-xs='mat-card-desktop'>
                <mat-card-title>
                    <div class='title'>GAMES KEEPER</div>
                    <div class='sub-title'>INDIVIDUAL/GROUPS/TRIPS</div>

                </mat-card-title>
                <mat-card-content fxLayout='column'>
                    <div class='price-box'>
                        <div class='price'>FREE</div>
                        <div class='price-comment'>FOR 4 PLAYERS</div>
                    </div>
                    <div class='item'>
                        <i class='fa fa-check'></i> Add Round/Score</div>
                    <div class='item'>
                        <i class='fa fa-check'></i> Event Scheduler</div>
                    <div class='item'>
                        <i class='fa fa-check'></i> Hole-by-Hole Results</div>
                    <div class='item'>
                        <i class='fa fa-check'></i> Multi-tee Options</div>
                    <div class='item'>
                        <i class='fa fa-check'></i> Unlimited Events/Month</div>
                </mat-card-content>
                <mat-card-footer>
                    <button mat-button class='card-footer' fxLayout='row' fxLayoutAlign='center center' (click)='createTripNow()'>
                        <i class='fa fa-chevron-right'></i>
                    </button>
                </mat-card-footer>
            </mat-card>
            <mat-card [@flipInX]='animatePricing()'  ngClass.lt-sm='mat-card-mobile' ngClass.gt-xs='mat-card-desktop'>
                <mat-card-title>
                    <div class='title'>LEAGUE</div>
                    <div class='sub-title'>TIME SAVER</div>

                </mat-card-title>
                <mat-card-content fxLayout='column'>
                    <div class='price-box'>
                        <div class='price-comment' style='margin-top:0px'>Starting at</div>
                        <div class='price' style='margin-top:0px'>$99.99</div>
                        <div class='price-comment' style='margin-top:0px'>PER MONTH</div>
                    </div>
                    <div class='item'>
                        <i class='fa fa-check'></i> Starting at 8 Foursome</div>
                    <div class='item'>
                        <i class='fa fa-check'></i> Full field Leaderboad</div>
                    <div class='item'>
                        <i class='fa fa-check'></i> Unlimited Players</div>
                    <div class='item'>
                        <i class='fa fa-check'></i> Self Registration</div>
                    <div class='item'>
                        <i class='fa fa-check'></i> Cross Foursome Nassau</div>
                </mat-card-content>
                <mat-card-footer>
                    <button mat-button class='card-footer' fxLayout='row' fxLayoutAlign='center center' (click)='joinNowLeague()'>
                        <i class='fa fa-chevron-right'></i>
                    </button>
                </mat-card-footer>
            </mat-card>
            <mat-card [@flipInY]='animatePricing()' ngClass.lt-sm='mat-card-mobile' ngClass.gt-xs='mat-card-desktop'>
                <mat-card-title>
                    <div class='title'>TOURNAMENTS</div>
                    <div class='sub-title'>PROFESSIONAL SCORING</div>

                </mat-card-title>
                <mat-card-content fxLayout='column'>
                    <div class='price-box'>
                        <div class='price'>$499.99</div>
                        <div class='price-comment'>PER EVENT</div>
                    </div>
                    <div class='item'>
                        <i class='fa fa-check'></i> 144 Player Field</div>
                    <div class='item'>
                        <i class='fa fa-check'></i> Accurate Results</div>
                    <div class='item'>
                        <i class='fa fa-check'></i> No Setup Fee</div>
                    <div class='item'>
                        <i class='fa fa-check'></i> Quick Wrap-up</div>
                    <div class='item'>
                        <i class='fa fa-check'></i> Easy to use</div>
                </mat-card-content>
                <mat-card-footer>
                    <button mat-button class='card-footer' fxLayout='row' fxLayoutAlign='center center' (click)='createTourneyNow()'>
                        <i class='fa fa-chevron-right'></i>
                    </button>
                </mat-card-footer>

            </mat-card>
        </div>
    </div>
</section>